namespace TabAurous {
    export interface CommonStock {
        StockId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        TransId?: number;
        TransItemId?: number;
        VoucherDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        CompanyId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        Lab?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        UnitRate?: number;
        ImageName?: string;
        HUID?: string;
        Hallmark?: number;
        StockAllocation?: boolean;
        FinancialYearId?: number;
        RefVoucherId?: number;
        POSCustomerId?: number;
        Purity?: number;
        PureWeight?: number;
        SetId?: number;
        ExportPieces?: number;
        MFAmount?: number;
        MF?: number;
        BOMDetails?: CommonBOM[];
    }
}
